import { render, staticRenderFns } from "./EditGroupName.vue?vue&type=template&id=6d19f3b6"
import script from "./EditGroupName.vue?vue&type=script&lang=js"
export * from "./EditGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports